import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from 'semantic-ui-react';
import * as classes from './classes.module.scss';

const renderPrice = (itemsPrice, discount, currency) => (
  discount > 0 ? (
    <>
      <s>
        { currency }
        { itemsPrice.toFixed(2) }
      </s>
      &nbsp;
      { currency }
      { (itemsPrice - discount).toFixed(2) }
    </>
  ) : (
    <>
      { currency }
      { itemsPrice.toFixed(2) }
    </>
  )
);

const WallGroup = ({
  name, badge, status, times, count, itemsPrice, discount, currency, complete, onAddGroup
}) => {
  if (!name) {
    return null;
  }

  return (
    <div className={ classes.groupHeader }>
      <div className={ classes.groupTitle }>
        { name }
        {
          badge ? (
            <span
              className={ classnames(classes.badge, complete ? classes.badgeOn : classes.badgeOff) }
            >
              { badge }
            </span>
          ) : null
        }
        { times > 1 ? ` ×${ times }` : null }
      </div>
      <div className={ classes.groupPrice }>
        { count }
        &nbsp;items&nbsp;
        { renderPrice(itemsPrice, discount, currency) }
      </div>
      {
        status ? (
          <div className={ classes.groupStatus }>
            { status }
          </div>
        ) : null
      }
      <div className={ classes.groupButton }>
        <Button fluid onClick={ onAddGroup }>
          { complete ? 'ADD WALL TO CART' : `ADD ${ count } ITEMS TO CART` }
        </Button>
      </div>
    </div>
  );
};

WallGroup.propTypes = {
  name: PropTypes.string,
  badge: PropTypes.string,
  status: PropTypes.string,
  times: PropTypes.number,
  count: PropTypes.number.isRequired,
  itemsPrice: PropTypes.number,
  discount: PropTypes.number,
  currency: PropTypes.string,
  complete: PropTypes.bool,
  onAddGroup: PropTypes.func.isRequired
};

export default WallGroup;
